// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"51e4cce4","186":"b4990a13","225":"15808e63","272":"7ac05304","372":"c78d9efc","377":"3eff3d13","573":"449e788a","738":"fa1bbc20","841":"f17f3f1c","856":"9738ebd6"}[chunkId] + ".chunk.js";
};